<div class="server-icon flex-center" [style.width.px]="size" [style.height.px]="size"
	 [style.border-radius.px]="size / 4">
	<img [width]="size * 0.5" *ngIf="server.type" [src]="'assets/servers/' + server.type + '.svg'" class="filter-accent"
		 alt="">
	<img [width]="size * 0.5" *ngIf="!server.type" src="assets/servers/other.svg" class="filter-accent">
</div>
